import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import moment from "moment";
import ReactPlayer from "react-player";
import EnterImage from "../../assets/images/unsplash_hUHzaiAHuUc.png";
import Nodata from "../../assets/Icon/Nodata.png";
import { serverInfo } from "../../App";
import { useContext } from "react";
const PromotionalCard = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 8;
  const { data } = props;

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      {currentItems.length !== 0 ? (
        <>
          <div className="row">
            {currentItems.map((event_data) => {
              return (
                <div className="col-md-3 mb-3">
                  <div className="card bg-dark completedMeetupBlack BlueBorder">
                    <img
                      src={
                        event_data.image
                          ? imageCdnUrl+event_data.image
                          : EnterImage
                      }
                      className="img-fluid p-2 ImgBlue"
                      alt=""
                      style={{
                        height: "200px",
                        width: "300px",
                      }}
                    />
                    <div className="p-3">
                      <center>
                        <h5 className="text-white text-center">
                          {event_data.audition.title ?? ""}
                        </h5>
                        <Link to={`${props.urlLink}/${event_data?.id}`}>
                          <button className="btn BlueBtn w-100">View</button>
                        </Link>
                      </center>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div id="react-paginate">
            <ReactPaginate
              breakLabel="..."
              nextLabel="next >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              pageCount={pageCount}
              previousLabel="< previous"
              renderOnZeroPageCount={null}
              breakLinkClassName={"page-link"}
              containerClassName={"pagination"}
              pageLinkClassName={"page-link"}
              previousLinkClassName={"page-link"}
              nextLinkClassName={"page-link"}
              activeClassName={"active"}
            />
          </div>
        </>
      ) : (
        <>
          <div className="row justify-content-center align-items-center">
            <div className="d-flex col-md-12 justify-content-center align-items-center my-5">
              <img src={Nodata} alt="" className=" Nodata" />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default PromotionalCard;
